var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"localidades container"},[_c('custom-select',{attrs:{"label":"Localidad","value":_vm.value,"name":_vm.name,"items":_vm._localidades,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }